<style lang="less">
    @import "../../../../styles/common-table-list.less";
</style>
<template>
<div class="center-table-list">
    <div class="table-list lookmember" style="margin-top:25px;height: auto;min-height: 726px;">
        <div class="table-list-title">
            <span style="margin-left:25px">预充值优惠明细</span>
            <span style="margin-right:25px" v-if="preMoneyStr != ''">您的预充值帐户级别为{{preMoneyStr && preMoneyStr}}</span>
        </div>
        <Row class-name="look-row">
            <Col :span="12" style="padding-left: 44px;">
                版权服务类型
            </Col>
            <Col :span="8">优惠价格</Col>
            <Col :span="4">操作</Col>
        </Row>
        <div>
            <Row class-name="rowcolor contentTable" v-if="tableArr.length>0" v-for="(item,index) in tableArr" :key="index">
                <Col :span="12" style="padding-left: 44px;">
                    <span class="con_tit">{{item.title}}</span>
                    <span class="con_txt">{{item.desc}}</span>
                </Col>
                <Col :span="8" style="line-height:87px">{{item.amount}}</Col>
                <Col :span="4" style="margin-top: 27px;">
                    <input @click="jumpload(item)" type="button" value="使用" />
                </Col>
            </Row>
            <div v-if="phoneArr.length>0" style="position: relative;">
                 <Row style ="border:none;" class-name="rowcolor contentTable" v-for="(item,index) in phoneArr" :key="index">
                    <Col :span="12" style="padding-left: 44px;border-bottom: 1px solid #F7F9FB;border-right: 1px solid #F7F9FB;">
                        <span class="con_tit">{{item.title}}</span>
                        <span class="con_txt">{{item.desc}}</span>
                    </Col>
                </Row>
                <Col style="position: absolute;left:65%;top:49%;">增值服务请联系客服：400-878-5066</Col>
            </div>
           
        </div>
        
        <div class="empty-box" v-if="tableArr.length<=0">
            <img src="@/assets/empty.png" class="empty-img" />
            <p>表单暂无数据哦～</p>
        </div>
    </div>
    <div style="text-align:center"><button class="goBtn" @click="immediatePayment()" v-if="tableArr.length>0">{{showText}}</button></div>
    <vipTypeGoOn :subBizType="subBizTypesb" routerLink = "go" :payMoney="payMoney" @fatherModal="fatherModal" mywidth='838' myheight="585" myTitleheight="50" v-if="showModal" />
</div>
</template>

<script>
    import vipTypeGoOn from '../../vip/lawcomponent/vipTypeGoOn.vue'
    import { userInfo} from "@/api/index";
    import Cookies from "js-cookie";
    import {getPrechargList,getPrechargStatus} from '@/api/staticPage';
    export default {
        metaInfo: {
            title: '预充值权益|时尚知识产权保护平台',
            meta: [{                 // set meta
                name: 'keyWords',
                content: ''
            },{
                name: 'Description',
                content: ''
            }]
        },
        name:'preRcharge',
        data(){
            return {
                preMoneyStr:"",
                showList:{},
                showDialog03:!1,
                accountType:"",
                showText:'继续充值',
                userInfo:"",
                tableArr:[],
                phoneArr:[],
                showModal:!1,
				subBizTypesb:'',
                payMoney:'0',
            }
        },
        components:{
            vipTypeGoOn
        },
        methods:{
            preMoney(){
                getPrechargStatus().then(res=>{
                    if(res.code == 200){
                        let dengji = Number(res.result.grade)
                        switch (dengji) {
                            case 0:
                                this.preMoneyStr = "黄金级"
                                break;
                            case 1:
                                this.preMoneyStr = "钻石级"
                                break;
                            case 2:
                                this.preMoneyStr = "皇冠级"
                                break;
                        }
                    }else{
                        //toast(res.message)
                    }
                })
            },
            fatherModal() {
                let _this = this;
                _this.showModal = !1;
            },
            immediatePayment(){
                // this.$router.push({ path:'/memberInfo' })
                let _this = this;
                // _this.getUserStaus();
                /**
                 * 这里原来用_this.getUserStaus，但是，实名认证通过后，第一次获取状态的时候，userInfo()的请求截取不到，第二次就可以了，
                 * 死活找不到原因，ansyc await 也测试了，只能把判断写在获取用户信息里面
                 */
                userInfo().then(res=>{
                    console.log("获取用户状态返回值 ：：：：",res);
                    // debugger

                    if(res.code=="200"){
                        let uInfo = res.result;
                        Cookies.set("userInfo", JSON.stringify(res.result));
                        _this.setStore("userInfo", uInfo );
                        if(uInfo ==''){
                            toast('请登录后再操作')
                            return false;
                        }
                        if(uInfo.realNameStatus != 'complete_real_name'){
                            toast('请实名认证后再操作',function(){
                                _this.$router.push({
                                    path:'/authentication'
                                })
                            })
                            return  false
                        }
                        _this.showModal = !0;
                        // _this.subBizTypesb = money.code
                        // _this.payMoney = money.value
                    }else{
                        toast(res.message);
                    }
                });
            },
            jumpload(data){
                if(data.code == 1001){
                    let query = {
                        code: data.code
                    };
                    this.$router.push({ path:'/apply-cert',query: query })
                }else{
                  let query = {
                    code: data.code
                  };
                    this.$router.push({ path:'/copyrightLogin',query: query })
                }
            },
            _getPrechargList(){
                getPrechargList().then(res => {
                    if(res.code== 200){
                        if(res.result == null || res.result == ""){

                        }else{
                            for(let i in res.result){
                                if(res.result[i].onlineFlag == 1){
                                    this.tableArr.push(res.result[i])
                                }
                                if(res.result[i].onlineFlag == 0){
                                    this.phoneArr.push(res.result[i])
                                }
                            }
                        }
                    }else{
                        // toast(res.message)
                    }
				}); 
            }
        },
        mounted(){
            this._getPrechargList()
            this.preMoney()
        },
        created(){  
            // let _this = this;
            // let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
            // this.userInfo = userInfo
        },
    }
</script>

<style scoped lang="less">
.contentTable{
		// padding-left: 44px;
		// box-sizing: border-box;
		height: 87px;
		border-bottom:1px solid #e5e5e5;
		.con_tit{
			font-size: 16px;
			color: #181818;
			line-height: 22px;
			margin:20px 0 8px 0;
			display: block;
		}
		.con_txt{
			line-height: 17px;
			font-size: 12px;
			color: #999999;
			i{
				font-style:inherit;
				color:#FD273A;
			}
		}
	}
	.contentTable:last-child{
		border: none;
	}
    .lookmember{
        // width:1334px;
        margin:0px auto 30px;
        background:rgba(255,255,255,1);
        box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
        border-radius:2px;
        .looktitle{
            // width:1334px;
            height:63px;
            background:rgba(255,255,255,1);
            box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
            border-radius:2px 2px 0px 0px;
            font-size: 14px;
            color:rgba(51,51,51,1);
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .look-row{
            // width:1334px;
            height:50px;
            line-height: 50px;
            background:rgba(251,251,251,1);
            font-size: 14px;
            color:rgba(50,50,50,1);
        }
        .rowcolor{
            // width:1334px;
            height:87px;
            // line-height: 65px;
            background:rgba(255,255,255,1);
            border-bottom:1px solid #F7F9FB;
            font-size: 14px;
            color:rgba(102,102,102,1);           
            input{
                width:84px;
                height:33px;
                background:rgba(246,246,246,1);
                border-radius:2px;
                border:1px solid rgba(239,239,239,1);
                line-height:33px;
                font-size: 12px;
                color:rgba(51,51,51,1);
                outline: none;
                border: none;
                cursor: pointer;
            }
            input:hover{
                background:#121210; 
                border:1px solid #121210;
                color: #fff;
            }
        }
    }
    .goBtn{
        width:230px;
        height:42px;
        line-height: 42px;
        border:0px;
        background:#121210;
        border-radius:4px;
        outline: none;
        cursor: pointer;
        font-size:14px;
        font-weight:600;
        color:#fff;
        margin-bottom: 50px;
         }
</style>